<template>
  <div
    class="gw_message"
    :class="message.type ? `gw_message_type_${message.type}` : ''"
    :style="message.css_style"
    :data-tst="`message_${message.type}`"
    :tabindex="tabindex"
    @click="$emit('close', message)"
    @keydown.esc="$emit('esc:close', message)"
  >
    <div class="gw_message_back">
      <slot name="icon">
        <i
          v-if="message.type"
          style="font-size: var(--font-icon)"
          class="mdi"
          :class="message.icon || icons[message.type]"
        ></i>
      </slot>
      <slot>
        <span
          :data-tst="`gw_message_text`"
          v-html="message.text"
        />
      </slot>
      <i
        v-if="message.hasClose"
        style="cursor: pointer; z-index: 4; font-size: var(--close-font-size)"
        class="icon_btn notranslate mdi mdi-close"
        :data-tst="`${tstPrefix}gw_message_close`"
      ></i>
    </div>
  </div>
</template>
<script>
export default {
  name: 'GwMessage',
  props: {
    message: {
      default: () => ({}),
      required: true,
    },
    tabindex: { type: Number, default: -1 },
    tstPrefix: { type: String, default: '' },
  },
  emits: ['close'],
  data() {
    this.icons = {
      error: 'mdi-alert',
      warning: 'mdi-exclamation',
      success: 'mdi-check-circle',
      info: 'mdi-information-outline',
    }
    return {}
  },
}
</script>

<style scoped lang="scss">
.gw_message {
  --back-opacity: 0.5;
  --back-padding: 0.75rem 2rem;
  --clr-back: var(--clr-back-0);
  --font-icon: 2rem;
  --gap: 1.25rem;
  --font-size: 1rem;
  --close-font-size: 2rem;

  border-radius: 8px;
  border: 2px solid var(--clr-back);
  background: var(--clr-back);
  z-index: var(--z-index-messages) !important;
  font-weight: 500;
  font-size: var(--font-size);
  overflow: hidden;

  &_link {
    color: var(--clr-white-0);
    text-decoration: underline !important;
  }

  &_type {
    &_error {
      --clr-back: var(--clr-error);
    }
    &_warning {
      --clr-back: var(--clr-orange);
    }
    &_success {
      --clr-back: var(--clr-primary);
    }
    &_info {
      --clr-back: var(--clr-blue-1);
    }
  }
  // &:focus,
  // &:active {
  //   box-shadow: 0px 0px 0px 2px var(--clr-back);
  // }

  &_back {
    background: rgba(0, 0, 0, var(--back-opacity));
    display: flex;
    gap: var(--gap);
    justify-content: center;
    align-items: center;
    padding: var(--back-padding);
  }
}
</style>
